import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

const MIN_IDLE_TIMEOUT_MS = 60_000;
const DEFAULT_IDLE_TIMEOUT_MS = (() => {
  const raw = process.env.REACT_APP_SANDBOX_IDLE_TIMEOUT_MS;
  const parsed = raw ? Number(raw) : NaN;
  if (Number.isFinite(parsed) && parsed >= MIN_IDLE_TIMEOUT_MS) {
    return parsed;
  }
  return 10 * 60 * 1000; // 10 minutes
})();

interface UserActivityState {
  lastInteractionAt: number;
  isIdle: boolean;
  idleTimeoutMs: number;
  setIdleTimeoutMs: (timeoutMs: number) => void;
  updateActivity: (timestamp: number) => boolean;
  setIdle: () => boolean;
}

export const useUserActivityStore = create<UserActivityState>()(
  devtools((set, get) => ({
    lastInteractionAt: Date.now(),
    isIdle: false,
    idleTimeoutMs: DEFAULT_IDLE_TIMEOUT_MS,
    setIdleTimeoutMs: (timeoutMs: number) => {
      const normalized = Number.isFinite(timeoutMs) ? Math.max(timeoutMs, MIN_IDLE_TIMEOUT_MS) : MIN_IDLE_TIMEOUT_MS;
      if (normalized === get().idleTimeoutMs) {
        return;
      }
      set({ idleTimeoutMs: normalized });
    },
    updateActivity: (timestamp: number) => {
      const state = get();
      if (timestamp <= state.lastInteractionAt && state.isIdle === false) {
        return false;
      }
      set({ lastInteractionAt: timestamp, isIdle: false });
      return true;
    },
    setIdle: () => {
      if (get().isIdle) {
        return false;
      }
      set({ isIdle: true });
      return true;
    },
  }))
);

